import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { mustBeArray } from '../../utils/lib';
import CollectionChart from './CollectionChart';


const getVolumes = ({type, data}) => {
  return data && data.pickups && data.pickups[0] && data.pickups[0][type];
};
const CollectionHistory = ({collectionHistory}) => {
    const customizeGraphData = (data) => {
        let updatedList = _.groupBy(data, 'locationId');
        let finalList = [];
        mustBeArray(Object.values(updatedList)).forEach((collectionData, i) => {
          let updatedData = collectionData.map((eachData) => {
            return ({...eachData, 
                          runDate: getVolumes({data: eachData, type: "runDate"}),  
                          expectedVolume: getVolumes({data: eachData, type: "calculatedLitres"}), 
                                actualVolume: getVolumes({data: eachData, type: "estimatedLitresPickedUp"})});
          });
          finalList = [...finalList, [...mustBeArray(updatedData)]];
        });
        return finalList;
    };
    return (<Card className="p-1">
                <CardTitle className="mb-2">Collection History</CardTitle>
                <CardBody>
                  {
                    mustBeArray(customizeGraphData(collectionHistory)).map((data,i) => {
                      return(
                        <CollectionChart data={data} key={i} />
                      );
                    })
                  }
                </CardBody>
            </Card>);
};
export default CollectionHistory;